import { ResGetSignatures, SignatureFilter } from '../types/api-types';
import { BaseOrganizationEndpoints } from './base';
import { ResponseWithStatus } from './response/response_with_status';

export class Signatures extends BaseOrganizationEndpoints {
  async signatures(
    filter: SignatureFilter
  ): Promise<ResponseWithStatus<ResGetSignatures>> {
    let query = '';
    if (filter.signature_id) {
      query += `?signature=${encodeURIComponent(filter.signature_id)}`;
    } else if (filter.user_id) {
      query += `?user=${encodeURIComponent(filter.user_id)}`;
    } else if (filter.visit_id) {
      query += `?visit=${encodeURIComponent(filter.visit_id)}`;
    }

    return this.requestWithStatus<ResGetSignatures>(
      'GET',
      `/signatures${query}`
    );
  }
}
